import { CommonUtilities } from 'commonUtils';
import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';

export default function ProductStatusExtUpsert(param: any) {

    let [ProductExtStatus, setProductExtStatus] = useState<any>(param?.editDataDawer ?? []);

    const closeDrawer = () => { param.closeDrawer() }

    const onReset = () => {
        console.log(param?.editDataDawer)
        if (param?.editDataDawer) {
            ProductExtStatus = param?.editDataDawer
            setProductExtStatus(ProductExtStatus)
        }
    }

    const onSave = () => {
        systemFormatsList.saveStatusProductExt(ProductExtStatus).then((respond: any) => {
            CommonUtilities.showToastDawer('Product Status Ext Saved', 'Success')
        })
    }

    return (<>

        <Drawer open={param?.openUpsertUX} direction='right' className='react-drawer allowHscroll ' size={800}>

            <div className="pull-right ws-5 box full-height-vh " >

                <div className="ws-12 bg-blue ">
                    <h1 className="pull-left text-center mt mll">Add Product Status Ext</h1>
                    <i className="icon-close pull-right pLarge" onClick={closeDrawer}></i>
                </div>

                <div className="box-content">

                    <div className="ws-12">

                        <div className="ws-12 pb pt">
                            <label className="ws-12 text-bold">Product Status Ext Parent  </label>
                            <input className="ws-12" type="text" placeholder="Product Status Ext Parent" data-ng-model="productStatusExtParent" id="ProductStatusExtParent" name="ProductStatusExtParent" />
                        </div>

                        <div className="ws-12 pb pt">
                            <label className="ws-12 text-bold">Product Status Ext UseID</label>
                            <input className="ws-12" type="number" placeholder="Product Status Ext Use ID" ng-disabled="IsDisabled" data-ng-model="productStatusExtUseID" id="ProductStatusExtUseID" name="ProductStatusExtUseID" />
                        </div>

                        <div className="ws-12 pb pt">
                            <label className="ws-12 text-bold">Product Status Ext Name</label>
                            <input className="ws-12" type="text" placeholder="Product Status Ext Name" data-ng-model="productStatusExtName" id="ProductStatusExtName" name="ProductStatusExtName" />
                        </div>

                        <div className="ws-12 pb pt">
                            <label className="ws-12 text-bold"> Product Status Ext Short Code</label>
                            <input className="ws-12" type="text" placeholder="Product Status Ext Short Code" data-ng-model="productStatusExtShortCode" id="ProductStatusExtShortCode" name="ProductStatusExtShortCode" />
                        </div>

                        <div className="ws-12 pb pt">
                            <label className="ws-12 text-bold pb">IsDefault</label>
                            <div className="label-entries">
                                <label className="switch mr">
                                    <input type="checkbox" data-ng-model="productStatusExt.isDefault" />
                                    <span className="slider round text-left white pm pts " ng-show="productStatusExt.isDefault=='1'">Yes</span>
                                    <span className="slider round text-right white pm pts sliderOff" ng-show="!productStatusExt.isDefault =='1'">No</span>
                                </label>
                            </div>
                        </div>
                    </div>

                </div>

                {/* Footer */}
                <div className="box-footer ws-12 pull-right">
                    <button type="button" className="icon-btn delete pull-right" onClick={closeDrawer}>x Close</button>
                    <button type="button" className="icon-btn delete pull-right" onClick={onReset}>↻ Reset</button>
                    <button type="button" className="icon-btn edit pull-right" onClick={onSave}>✔ Save </button>
                </div>
            </div>

        </Drawer>
    </>)
}